module.exports = __webpack_public_path__ + "static/media/biking-mountain.de481fa1.svg";